<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card class="pa-2">
      <!-- FILTER -->
      <v-row dense align="center">
        <!-- Tahun -->
        <v-col cols="2">
          <v-select
            v-model="pagination.year"
            :items="yearOptions"
            label="Tahun"
            prepend-inner-icon="mdi-calendar"
            dense
            outlined
            hide-details
            clearable
            @change="onYearChange()"
          />
        </v-col>

        <!-- Worksheet -->
        <v-col cols="5">
          <v-autocomplete
            v-model="pagination.worksheet"
            :items="listWorksheet"
            label="Kertas Kerja Budget"
            prepend-inner-icon="mdi-file-document-outline"
            :item-text="(item) => `${item.worksheet_name}`"
            item-value="id"
            outlined
            dense
            clearable
            hide-details
            @change="onWorksheetChange"
          />
        </v-col>

        <!-- departement -->
        <v-col cols="3">
          <v-select
            v-model="pagination.departement_id"
            :items="listdepartement"
            label="Departement"
            prepend-inner-icon="mdi-office-building-outline"
            dense
            outlined
            clearable
            hide-details
            :item-text="(item) => `${item.mst_division_name}`"
            item-value="mst_division_id"
            @change="ondepartementChange()"
          />
        </v-col>

        <!-- site -->
        <v-col cols="2">
          <v-select
            v-model="pagination.site_id"
            :items="listSite"
            label="Lokasi Kerja"
            prepend-inner-icon="mdi-map-marker-outline"
            dense
            outlined
            clearable
            hide-details
            item-text="dc_code"
            item-value="mst_site_id"
            @change="onsiteChange()"
          />
        </v-col>

        <!-- corporate -->
        <v-col cols="4">
          <v-select
            v-model="pagination.corporate_id"
            :items="listCorporate"
            label="Perusahaan"
            prepend-inner-icon="mdi-domain"
            dense
            outlined
            clearable
            hide-details
            item-text="mst_corporate_name"
            item-value="mst_corporate_id"
            @change="oncorporateChange()"
          />
        </v-col>

        <v-col cols="3">
          <v-select
            v-model="pagination.lastStatus"
            :items="listStatus"
            label="Status"
            dense
            outlined
            clearable
            hide-details
            item-text="name"
            item-value="id"
            @change="onStatusChange()"
          />
        </v-col>
      </v-row>

      <!-- SEARCH & BUTTON -->
      <v-row dense align="center" class="mt-1">
        <!-- Search -->
        <v-col cols="3">
          <v-text-field
            v-model="pagination.search"
            label="Cari Budget..."
            prepend-inner-icon="mdi-magnify"
            dense
            outlined
            clearable
            hide-details
            @input="debouncedSearch"
          />
        </v-col>

        <!-- Button -->
        <v-col cols="4">
          <v-btn
            color="primary"
            class="text-none px-5"
            elevation="2"
            @click="openDialogCreate()"
          >
            <v-icon left small>mdi-plus</v-icon>
            Tambah Budget
          </v-btn>
        </v-col>
      </v-row>

      <!-- TABLE -->
      <v-row>
        <v-col>
          <div class="table-wrapper">
            <v-data-table
              mobile-breakpoint="0"
              fixed-header
              dense
              class="elevation-5"
              :headers="tableHeaders"
              :items="List"
              :items-per-page.sync="pagination.itemsPerPage"
              :page.sync="pagination.page"
              :sort-by="pagination.sortBy"
              :sort-desc="pagination.sortDesc"
              :loading="isLoading"
              :server-items-length="total"
              item-key="id"
              @update:page="updateQuery('page', $event)"
              @update:items-per-page="updateQuery('itemsPerPage', $event)"
              @update:sort-by="updateQuery('sortBy', $event)"
              @update:sort-desc="updateQuery('sortDesc', $event)"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td>
                      <span
                        @click="openDialogDetail(item)"
                        class="px-2 py-1 rounded text-caption d-inline-flex align-center"
                        style="
                          background-color: #eeeeee;
                          color: #757575;
                          cursor: pointer;
                        "
                      >
                        {{ item.transaction_number }}
                      </span>
                    </td>
                    <!-- Nama -->
                    <td class="text-center">
                      {{ item.worksheet_budget_name }}
                    </td>

                    <!-- Nama -->
                    <td class="text-center">
                      {{ item.departement_name }}
                    </td>

                    <!-- Nama -->
                    <td class="text-center">
                      {{ item.dc_code }}
                    </td>

                    <!-- Nama -->
                    <td class="text-center">
                      {{ item.corporate_name }}
                    </td>

                    <td class="text-center">
                      <span
                        @click="openDialogPic(item)"
                        class="px-2 py-1 rounded text-caption d-inline-block"
                        style="
                          background-color: #f5f5f5;
                          color: #616161;
                          cursor: pointer;
                        "
                      >
                        {{ item.step_name || "-" }}
                      </span>
                    </td>

                    <td class="text-center">
                      <v-chip
                        :color="getStatusColor(item.last_status)"
                        size="x-small"
                        variant="tonal"
                        class="text-caption text-capitalize text-center"
                        style="height: 20px"
                      >
                        {{ item.last_status }}
                      </v-chip>
                    </td>

                    <td class="text-center">
                      <v-tooltip
                        bottom
                        v-if="item.action_history_approval === 't'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            @click="openDialogApproval(item.id)"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        Tampilkan
                      </v-tooltip>
                    </td>

                    <td>
                      <div style="font-size: 12px">
                        {{ item.created_by_name }}
                      </div>

                      <div style="font-size: 12px">{{ item.created_on }}</div>
                    </td>

                    <td class="text-center">
                      <div
                        v-if="item.last_status == 'created'"
                        class="d-flex justify-center align-center"
                        style="gap: 4px"
                      >
                        <!-- DELETE -->
                        <v-tooltip text="Cancel">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              size="x-small"
                              variant="text"
                              color="error"
                              @click="openDialogDelete(item)"
                            >
                              <v-icon size="16">mdi-delete-outline</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- create -->
    <v-dialog v-model="isDialogCreate" max-width="1000" persistent>
      <v-card rounded="lg">
        <!-- HEADER -->
        <v-card-title class="d-flex align-center bg-primary text-white py-4">
          <v-icon class="mr-3">mdi-file-plus-outline</v-icon>

          <div>
            <div class="text-h6 font-weight-bold">Tambah Budget</div>

            <div class="text-caption">
              Lengkapi informasi budget yang akan dibuat
            </div>
          </div>

          <v-spacer />

          <v-btn
            icon
            variant="text"
            color="white"
            @click="isDialogCreate = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- CONTENT -->
        <v-form ref="formCreate" v-model="isFormCreateValid">
          <v-card-text class="pa-6">
            <!-- Informasi Budget -->
            <v-card variant="outlined" rounded="lg" class="mb-4">
              <v-card-subtitle class="pt-4 pb-2 font-weight-bold">
                Informasi Budget
              </v-card-subtitle>

              <v-divider />

              <v-card-text>
                <v-row>
                  <!-- Tahun -->
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="formCreate.year"
                      :items="yearOptionsCreate"
                      label="Tahun"
                      prepend-inner-icon="mdi-calendar"
                      dense
                      outlined
                      hide-details
                      clearable
                      :rules="[(v) => !!v || 'Tahun wajib dipilih']"
                    />
                  </v-col>

                  <!-- Worksheet -->
                  <v-col cols="12" md="9">
                    <v-autocomplete
                      v-model="formCreate.worksheet"
                      :items="listWorksheetCreate"
                      label="Kertas Kerja Budget"
                      prepend-inner-icon="mdi-file-document-outline"
                      :item-text="
                        (item) =>
                          `${item.part} - ${item.account} - ${item.name}`
                      "
                      item-value="id"
                      outlined
                      dense
                      clearable
                      hide-details
                      :rules="[(v) => !!v || 'Kertas kerja wajib dipilih']"
                      @change="onWorksheetChangeCreate"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Informasi Organisasi -->
            <v-card variant="outlined" rounded="lg">
              <v-card-subtitle class="pt-4 pb-2 font-weight-bold">
                Informasi Organisasi
              </v-card-subtitle>

              <v-divider />

              <v-card-text>
                <v-row>
                  <!-- Departement -->
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="formCreate.departement_id"
                      :items="listdepartementCreate"
                      label="Departement"
                      prepend-inner-icon="mdi-office-building-outline"
                      dense
                      outlined
                      clearable
                      hide-details
                      :rules="[(v) => !!v || 'Departemen wajib dipilih']"
                      :item-text="
                        (item) => `${item.mst_division_name} - ${item.part}`
                      "
                      item-value="mst_division_id"
                    />
                  </v-col>

                  <!-- Site -->
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="formCreate.site_id"
                      :items="listSiteCreate"
                      label="Lokasi Kerja"
                      prepend-inner-icon="mdi-map-marker-outline"
                      :rules="[(v) => !!v || 'Lokasi Kerja wajib dipilih']"
                      dense
                      outlined
                      clearable
                      hide-details
                      item-text="dc_code"
                      item-value="mst_site_id"
                    />
                  </v-col>

                  <!-- Corporate -->
                  <v-col cols="12" md="5">
                    <v-select
                      v-model="formCreate.corporate_id"
                      :items="listCorporateCreate"
                      label="Perusahaan"
                      prepend-inner-icon="mdi-domain"
                      :rules="[(v) => !!v || 'Perusahaan wajib dipilih']"
                      dense
                      outlined
                      clearable
                      hide-details
                      item-text="mst_corporate_name"
                      item-value="mst_corporate_id"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-form>

        <v-divider />

        <!-- FOOTER -->
        <v-card-actions class="px-6 py-4">
          <v-spacer />

          <v-btn
            variant="outlined"
            color="grey-darken-1"
            prepend-icon="mdi-close"
            @click="isDialogCreate = false"
          >
            Batal
          </v-btn>

          <v-btn
            color="primary"
            prepend-icon="mdi-content-save"
            :disabled="!isFormCreateValid"
            @click="submitCreate"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- detail -->
    <v-dialog v-model="isDialogDetail">
      <v-card class="rounded-0">
        <!-- HEADER -->
        <div class="dialog-header">
          <!-- CLOSE -->
          <v-btn
            icon
            variant="text"
            color="grey-darken-1"
            class="close-btn"
            @click="isDialogDetail = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <!-- TITLE -->
          <div class="px-6 pt-5 pb-3 d-flex justify-space-between align-start">
            <div>
              <div class="text-h5 font-weight-bold mb-1">
                {{ selectedItem?.transaction_number }}
              </div>
              <div class="text-caption text-medium-emphasis mb-3">
                Detail transaksi budget terpilih
              </div>

              <v-simple-table dense class="elevation-1">
                <tbody>
                  <tr>
                    <td style="width: 1%; white-space: nowrap">Account</td>
                    <td class="text-medium-emphasis pr-2" style="width: 1%">
                      :
                    </td>
                    <td>{{ selectedItem?.account || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Kertas Kerja</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.worksheet_budget_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Bagian</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.part || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Departement</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.departement_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Lokasi Kerja</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.dc_code || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Perusahaan</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.corporate_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Tahun</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.fiscal_year || "-" }}</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-text-field
                @keydown="(e) => e.key === '-' && e.preventDefault()"
                v-model.number="selectedItem.kenaikan_harga"
                label="Kenaikan Harga (%)"
                type="number"
                min="0"
                variant="outlined"
                density="compact"
                hide-details
                suffix="%"
                class="mt-3"
                style="max-width: 200px"
                @change="submitUpdateKenaikanHarga"
              />
            </div>
          </div>

          <!-- ACTION BAR -->
          <div
            class="px-6 pb-4 d-flex align-center justify-space-between flex-wrap ga-4"
          >
            <div class="d-flex align-center ga-3 flex-wrap">
              <v-btn-toggle
                v-model="showMode"
                mandatory
                color="primary"
                density="comfortable"
                divided
              >
                <v-btn value="qty">
                  <v-icon start size="18">mdi-counter</v-icon>
                  Qty
                </v-btn>

                <v-btn value="values">
                  <v-icon start size="18">mdi-cash</v-icon>
                  Value
                </v-btn>

                <v-btn value="all">
                  <v-icon start size="18">mdi-view-grid</v-icon>
                  Semua
                </v-btn>
              </v-btn-toggle>

              <v-btn
                :disabled="
                  selectedItem.last_status?.toLowerCase().includes('approved')
                "
                large
                class="ml-2"
                color="primary"
                prepend-icon="mdi-plus"
                size="default"
                elevation="0"
                @click="openDialogDetailCreate"
              >
                Tambah Item
              </v-btn>
              <v-text-field
                v-model="searchDetail"
                placeholder="Cari item..."
                prepend-inner-icon="mdi-magnify"
                hide-details
                density="compact"
                variant="outlined"
                clearable
                class="mx-3"
                style="min-width: 280px; max-width: 350px"
              />
            </div>
          </div>

          <v-divider />
        </div>

        <v-data-table
          class="budget-table"
          density="compact"
          :headers="tableHeadersDetailFiltered"
          :items="filteredListDetail"
          :loading="isLoading"
          item-key="item_id"
          :items-per-page="5"
        >
          <template #body="{ items }">
            <tbody>
              <tr
                v-for="(item, index) in items"
                :key="index"
                :class="{
                  'new-item-row': Number(item.is_new) === 1,
                }"
              >
                <!-- REALIZATION -->
                <td class="text-center sticky-realization">
                  <v-btn
                    v-if="Number(item.is_new) !== 1"
                    icon
                    size="x-small"
                    color="primary"
                    variant="text"
                    @click="openDialogRealizationByWorksheetId(item)"
                  >
                    <v-icon size="16"> mdi-file-eye </v-icon>
                  </v-btn>
                </td>

                <!-- ITEM -->
                <td>
                  {{ item.item_name }}
                </td>

                <!-- material -->
                <td>
                  {{ item.material_name }}
                </td>

                <!-- ITEM -->
                <td>
                  {{ item.spesification }}
                </td>

                <!-- UOM -->
                <td>
                  {{ item.uom_name }}
                </td>

                <!-- note -->
                <!-- <td>
                  <v-text-field
                    v-model.number="item.note"
                    type="text"
                    density="compact"
                    variant="outlined"
                    hide-details
                    style="max-width: 90px"
                    @change="
                      submitUpdateDetailNote(
                        item.note,
                        item.fiscal_year,
                        item.item_id,
                        item.material_id,
                        item.spesification,
                      )
                    "
                  />
                </td> -->

                <!-- frekuensi -->
                <td>
                  <v-text-field
                    v-model.number="item.frekuensi"
                    type="number"
                    min="0"
                    density="compact"
                    variant="outlined"
                    hide-details
                    style="max-width: 90px"
                    @keydown="(e) => e.key === '-' && e.preventDefault()"
                    @change="
                      submitUpdateDetailFrekuensi(
                        parseInt(item.frekuensi),
                        item.id,
                        item.fiscal_year,
                        item.is_new,
                        item.item_id,
                        item.material_id,
                        item.uom_id,
                        item.spesification,
                        item.yearly_total_qty,
                        item.yearly_total_price,
                      )
                    "
                  />
                </td>

                <td>
                  <div class="d-flex align-center">
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      @click="openDialogChat(item)"
                    >
                      <v-icon>mdi-forum-outline</v-icon>
                    </v-btn>
                  </div>
                </td>
                <!-- QTY -->
                <template v-if="isQty">
                  <td
                    v-for="month in months"
                    :key="`qty-${item.item_id}-${month.id}`"
                    class="text-center"
                  >
                    <v-text-field
                      v-model.number="item[`${month.key}_qty`]"
                      :disabled="
                        (item.last_status?.toLowerCase() === 'created' &&
                          item.step_id) ||
                        item.last_status?.toLowerCase() === 'approved' ||
                        item[`${month.key}_disabled`] == 1
                      "
                      type="number"
                      min="0"
                      step="1"
                      variant="outlined"
                      density="compact"
                      hide-details
                      single-line
                      class="month-input"
                      @keydown="(e) => e.key === '-' && e.preventDefault()"
                      @change="
                        submitUpdateDetail(
                          'qty',
                          Math.round(item[`${month.key}_qty`]),
                          month.id,
                          item.fiscal_year,
                          item.item_id,
                          item.material_id,
                          item.spesification,
                        )
                      "
                    />
                  </td>
                </template>

                <!-- VALUE -->
                <template v-if="isValues">
                  <td
                    v-for="month in months"
                    :key="`value-${item.item_id}-${month.id}`"
                    class="text-center"
                  >
                    <v-text-field
                      v-model.number="item[`${month.key}_total_price`]"
                      :disabled="
                        (item.last_status?.toLowerCase() === 'created' &&
                          item.step_id) ||
                        item.last_status?.toLowerCase() === 'approved' ||
                        item[`${month.key}_disabled`] == 1
                      "
                      type="number"
                      min="0"
                      step="1"
                      variant="outlined"
                      density="compact"
                      hide-details
                      single-line
                      class="month-input"
                      @keydown="(e) => e.key === '-' && e.preventDefault()"
                      @change="
                        submitUpdateDetail(
                          'total_price',
                          Math.round(item[`${month.key}_total_price`]),
                          month.id,
                          item.fiscal_year,
                          item.item_id,
                          item.material_id,
                          item.spesification,
                        )
                      "
                    />
                  </td>
                </template>

                <td
                  class="text-right"
                  v-if="showMode === 'qty' || showMode === 'all'"
                >
                  {{ formatNumberRibuan(getItemTotalQty(item)) }}
                </td>

                <td
                  class="text-right"
                  v-if="showMode === 'values' || showMode === 'all'"
                >
                  {{ formatRupiahUtil(getItemTotalPrice(item)) }}
                </td>

                <!-- ACTION -->
                <td class="text-center sticky-action">
                  <v-tooltip text="Hapus data">
                    <template #activator="{ props }">
                      <v-btn
                        :disabled="
                          (item.last_status.toLowerCase() === 'created' &&
                            item.step_id) ||
                          item.last_status.toLowerCase() === 'approved'
                        "
                        v-bind="props"
                        icon
                        size="small"
                        color="error"
                        variant="text"
                        @click="openDialogDeleteDetail(item)"
                      >
                        <v-icon> mdi-delete-outline </v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <!-- FOOTER ACTION -->
        <v-divider />

        <div class="dialog-footer-sticky">
          <div>
            <div class="text-caption text-medium-emphasis">
              Pastikan seluruh item budget telah diperiksa
            </div>

            <div class="font-weight-medium">
              Budget akan dikirim untuk proses approval
            </div>
          </div>

          <v-btn
            :disabled="
              selectedItem.last_status?.toLowerCase().includes('approved')
            "
            color="primary"
            size="large"
            prepend-icon="mdi-send"
            @click="submitUpdateStepId"
          >
            Submit Budget
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- delete -->
    <v-dialog v-model="isDialogDelete" max-width="420">
      <v-card rounded="xl">
        <!-- Header -->
        <v-card-title class="d-flex align-center">
          <v-icon color="warning" class="mr-2">
            mdi-alert-circle-outline
          </v-icon>

          <span class="text-h6 font-weight-bold"> Konfirmasi Pembatalan </span>
        </v-card-title>

        <v-divider />

        <!-- Content -->
        <v-card-text class="py-6">
          <div class="text-body-1 mb-2">
            Apakah Anda yakin ingin membatalkan budget berikut?
          </div>

          <div class="pa-3 rounded-lg grey lighten-4 font-weight-medium">
            {{ selectedItem?.transaction_number || "-" }}
          </div>

          <div class="caption mt-3 warning--text">
            Budget yang dibatalkan tidak dapat diproses kembali.
          </div>
        </v-card-text>

        <v-divider />

        <!-- Footer -->
        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn text color="secondary" @click="isDialogDelete = false">
            Batal
          </v-btn>

          <v-btn
            color="warning"
            depressed
            :loading="isLoading"
            @click="submitDelete"
          >
            <v-icon left> mdi-cancel </v-icon>

            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Riwayat Persetujuan -->
    <v-dialog v-model="isDialogOpenApproval" max-width="700px">
      <v-card>
        <!-- HEADER -->
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6">Riwayat Persetujuan</span>

          <!-- tombol X -->
          <v-btn icon variant="text" @click="isDialogOpenApproval = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <!-- TABLE -->
        <v-data-table
          mobile-breakpoint="0"
          :headers="tableHeadersApproval"
          :items="approvalList"
          class="elevation-1"
        />

        <v-divider></v-divider>

        <!-- ACTION -->
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="secondary"
            variant="outlined"
            @click="isDialogOpenApproval = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- List Pic -->
    <v-dialog v-model="isDialogOpenPic" max-width="500px">
      <v-card>
        <!-- HEADER -->
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6">Approver</span>

          <!-- tombol close (pojok kanan) -->
          <v-btn icon variant="text" @click="isDialogOpenPic = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <!-- TABLE -->
        <v-data-table
          mobile-breakpoint="0"
          :headers="tableHeadersPic"
          :items="listPic"
          class="elevation-1"
        />

        <v-divider></v-divider>

        <!-- ACTION -->
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="secondary"
            variant="outlined"
            @click="isDialogOpenPic = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- create detail -->
    <v-dialog v-model="isDialogCreateDetail" max-width="700">
      <v-card rounded="lg">
        <!-- HEADER -->
        <v-card-title class="px-6 py-4">
          <div class="d-flex align-center">
            <v-icon color="primary" size="28" class="mr-3">
              mdi-plus-circle-outline
            </v-icon>

            <div>
              <div class="text-h6 font-weight-bold">Tambah Detail Item</div>

              <div class="text-caption text-medium-emphasis">
                Tambahkan item budget baru beserta frekuensi dan nilai
                anggarannya
              </div>
            </div>
          </div>
        </v-card-title>

        <v-divider />

        <!-- CONTENT -->
        <v-form ref="formCreateDetail" v-model="isFormCreateDetailValid">
          <v-card-text class="pa-6">
            <v-row>
              <!-- ITEM -->
              <v-col cols="6">
                <v-autocomplete
                  v-model="formCreateDetail.item_id"
                  :items="listItem || []"
                  :search-input.sync="formCreateDetail.searchItem"
                  item-text="name"
                  item-value="id"
                  label="Item"
                  prepend-inner-icon="mdi-package-variant"
                  variant="outlined"
                  clearable
                  :rules="[(v) => !!v || 'Item wajib dipilih']"
                >
                  <template #no-data>
                    <div class="pa-3">
                      <div class="text-caption text-medium-emphasis mb-2">
                        Item tidak ditemukan
                      </div>

                      <v-btn
                        block
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi-plus"
                        @click="openItemDialog(form)"
                      >
                        Tambah {{ formCreateDetail.searchItem || "Item Baru" }}
                      </v-btn>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="6">
                <v-autocomplete
                  v-model="formCreateDetail.material_id"
                  :items="listMaterial || []"
                  :search-input.sync="formCreateDetail.searchMaterial"
                  item-text="name"
                  item-value="id"
                  label="Material"
                  prepend-inner-icon="mdi-cube-outline"
                  variant="outlined"
                  clearable
                  :rules="[(v) => !!v || 'Material wajib dipilih']"
                >
                  <template #no-data>
                    <div class="pa-3">
                      <div class="text-caption text-medium-emphasis mb-2">
                        Material tidak ditemukan
                      </div>

                      <v-btn
                        block
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi-plus"
                        @click="openMaterialDialog(form)"
                      >
                        Tambah
                        {{ formCreateDetail.searchMaterial || "Material Baru" }}
                      </v-btn>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="formCreateDetail.spesification"
                  label="Spesifikasi"
                  prepend-inner-icon="mdi-text-box-outline"
                  variant="outlined"
                  :rules="[(v) => !!v || 'Spesifikasi wajib diisi']"
                />
              </v-col>

              <!-- UOM -->
              <v-col cols="6">
                <v-autocomplete
                  v-model="formCreateDetail.uom_id"
                  :items="listUom || []"
                  :search-input.sync="formCreateDetail.searchUom"
                  item-text="name"
                  item-value="id"
                  label="Satuan (UOM)"
                  prepend-inner-icon="mdi-ruler"
                  variant="outlined"
                  clearable
                  :rules="[(v) => !!v || 'Satuan wajib dipilih']"
                >
                  <template #no-data>
                    <div class="pa-3">
                      <div class="text-caption text-medium-emphasis mb-2">
                        UOM tidak ditemukan
                      </div>

                      <v-btn
                        block
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi-plus"
                        @click="openUomDialog(form)"
                      >
                        Tambah {{ formCreateDetail.searchUom || "UOM Baru" }}
                      </v-btn>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>

              <!-- DETAIL -->
              <v-col cols="12">
                <v-sheet border rounded="lg" class="pa-4">
                  <div class="text-subtitle-2 font-weight-bold mb-4">
                    Detail Budget
                  </div>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="formCreateDetail.frekuensi"
                        label="Frekuensi"
                        type="number"
                        min="1"
                        prepend-inner-icon="mdi-repeat"
                        variant="outlined"
                        :rules="[
                          (v) => !!v || 'Frekuensi wajib diisi',
                          (v) => v > 0 || 'Frekuensi harus lebih dari 0',
                        ]"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="formCreateDetail.qty"
                        label="Quantity"
                        type="number"
                        min="1"
                        prepend-inner-icon="mdi-package-variant-closed"
                        variant="outlined"
                        @input="calculateTotalPrice"
                        :rules="[
                          (v) => !!v || 'Quantity wajib diisi',
                          (v) => v > 0 || 'Quantity harus lebih dari 0',
                        ]"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="formCreateDetail.unit_price"
                        label="Harga Satuan"
                        type="number"
                        min="0"
                        prefix="Rp"
                        prepend-inner-icon="mdi-currency-usd"
                        variant="outlined"
                        @input="calculateTotalPrice"
                        :rules="[
                          (v) => !!v || 'Harga Satuan wajib diisi',
                          (v) => v >= 0 || 'Harga Satuan tidak boleh negatif',
                        ]"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="formCreateDetail.total_price"
                        label="Total Harga"
                        type="number"
                        min="0"
                        prefix="Rp"
                        prepend-inner-icon="mdi-cash"
                        variant="outlined"
                        readonly
                      />
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model.number="formCreateDetail.total_price_budget"
                        label="Total Harga (Include Kenaikan Harga)"
                        type="number"
                        min="0"
                        prefix="Rp"
                        prepend-inner-icon="mdi-cash"
                        variant="outlined"
                        readonly
                      />
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>

        <v-divider />

        <!-- FOOTER -->
        <v-card-actions class="px-6 py-4">
          <v-spacer />

          <v-btn
            variant="outlined"
            color="grey"
            @click="isDialogCreateDetail = false"
          >
            Batal
          </v-btn>

          <v-btn
            :disabled="!isFormCreateDetailValid"
            color="primary"
            prepend-icon="mdi-content-save"
            @click="submitCreateDetail"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete detail -->
    <v-dialog v-model="isDialogDeleteDetail" max-width="420">
      <v-card rounded="xl">
        <!-- Header -->
        <v-card-title class="d-flex align-center">
          <v-icon color="warning" class="mr-2">
            mdi-alert-circle-outline
          </v-icon>

          <span class="text-h6 font-weight-bold"> Konfirmasi Pembatalan </span>
        </v-card-title>

        <v-divider />

        <!-- Content -->
        <v-card-text class="py-6">
          <div class="text-body-1 mb-2">
            Apakah Anda yakin ingin membatalkan budget berikut?
          </div>

          <div class="pa-3 rounded-lg grey lighten-4 font-weight-medium">
            {{ selectedItemDetail?.item_name || "-" }}
          </div>

          <div class="caption mt-3 warning--text">
            Budget yang dibatalkan tidak dapat diproses kembali.
          </div>
        </v-card-text>

        <v-divider />

        <!-- Footer -->
        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn text color="secondary" @click="isDialogDeleteDetail = false">
            Batal
          </v-btn>

          <v-btn color="warning" depressed @click="submitDeleteDetail">
            <v-icon left> mdi-cancel </v-icon>

            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- realization by worksheet -->
    <v-dialog v-model="isDialogOpenRealizationByWorksheetId" max-width="1200px">
      <v-card class="rounded-xl">
        <v-btn
          icon
          variant="text"
          color="grey-darken-1"
          class="close-btn"
          @click="isDialogOpenRealizationByWorksheetId = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="px-6 py-4">
          <div class="d-flex justify-space-between align-center w-100">
            <!-- LEFT -->
            <div>
              <div class="text-subtitle-1 font-weight-bold mb-1">Realisasi</div>

              <v-simple-table dense class="elevation-1">
                <tbody>
                  <tr>
                    <td style="width: 1%; white-space: nowrap">Kertas Kerja</td>
                    <td class="text-medium-emphasis pr-2" style="width: 1%">
                      :
                    </td>
                    <td>{{ selectedItem?.worksheet_budget_name || "-" }}</td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td style="width: 1%; white-space: nowrap">Account</td>
                    <td class="text-medium-emphasis pr-2" style="width: 1%">
                      :
                    </td>
                    <td>{{ selectedItem?.account || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Bagian</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.part || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Departement</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.departement_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Lokasi Kerja</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.dc_code || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Perusahaan</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.corporate_name || "-" }}</td>
                  </tr>

                  <tr>
                    <td style="white-space: nowrap">Tahun</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.fiscal_year - 1 || "-" }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </div>
        </v-card-title>

        <v-divider />

        <!-- CONTENT -->
        <v-data-table
          dense
          fixed-header
          class="elevation-1 no-wrap-table"
          :headers="tableHeadersRealizationByWorksheetId"
          :items="listRealizationByWorksheetId"
          :loading="isLoading"
          item-key="id"
          :items-per-page="5"
          :footer-props="{
            itemsPerPageOptions: [5, 10],
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td class="text-center cursor-pointer">
                  {{ item.item_name || "" }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ item.material_name || "" }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ item.spesification || "" }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ item.uom_name || "" }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ formatNumberRibuan(item.count_month_qty) || "" }}
                </td>

                <!-- JAN -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 1, 1)"
                >
                  {{ formatNumberRibuan(item.january_qty || 0) }}
                </td>

                <!-- FEB -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 2, 2)"
                >
                  {{ formatNumberRibuan(item.february_qty || 0) }}
                </td>

                <!-- MAR -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 3, 3)"
                >
                  {{ formatNumberRibuan(item.march_qty || 0) }}
                </td>

                <!-- APR -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 4, 4)"
                >
                  {{ formatNumberRibuan(item.april_qty || 0) }}
                </td>

                <!-- MAY -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 5, 5)"
                >
                  {{ formatNumberRibuan(item.may_qty || 0) }}
                </td>

                <!-- JUN -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 6, 6)"
                >
                  {{ formatNumberRibuan(item.june_qty || 0) }}
                </td>

                <!-- JUL -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 7, 7)"
                >
                  {{ formatNumberRibuan(item.july_qty || 0) }}
                </td>

                <!-- AUG -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 8, 8)"
                >
                  {{ formatNumberRibuan(item.august_qty || 0) }}
                </td>

                <!-- SEP -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 9, 9)"
                >
                  {{ formatNumberRibuan(item.september_qty || 0) }}
                </td>

                <!-- OCT -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 10, 10)"
                >
                  {{ formatNumberRibuan(item.october_qty || 0) }}
                </td>

                <!-- NOV -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 11, 11)"
                >
                  {{ formatNumberRibuan(item.november_qty || 0) }}
                </td>

                <!-- DEC -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 12, 12)"
                >
                  {{ formatNumberRibuan(item.december_qty || 0) }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ formatNumberRibuan(item.yearly_qty) || "" }}
                </td>
                <td class="text-center cursor-pointer">
                  {{ formatRupiahUtil(item.yearly_ending) || "" }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-divider></v-divider>

        <!-- ACTION -->
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- realization by month -->
    <v-dialog v-model="isDialogOpenRealizationByMonth" max-width="1200px">
      <v-card class="rounded-xl">
        <!-- HEADER -->
        <v-card-title class="d-flex justify-space-between align-center">
          <div>
            <div class="text-h6 font-weight-bold">
              Realisasi Kartu Buku Besar
            </div>
          </div>

          <div class="d-flex align-center ga-2">
            <v-tooltip text="Tutup Modal" location="bottom" open-delay="200">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                  size="small"
                  @click="isDialogOpenRealizationByMonth = false"
                >
                  <v-icon size="18">mdi-close</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </v-card-title>

        <v-divider />

        <!-- CONTENT -->
        <v-data-table
          dense
          fixed-header
          class="elevation-1"
          :headers="tableHeadersRealizationByMonth"
          :items="listRealizationSuccessByMonth"
          item-key="id"
          :items-per-page="5"
          :footer-props="{
            itemsPerPageOptions: [5, 10],
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td style="min-width: 180px">
                  {{ item.account || "-" }}
                </td>

                <td>
                  {{ item.transaksi_date || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.item_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.material_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.spesification || "-" }}
                </td>

                <td class="text-center">
                  {{ item.qty || 0 }}
                </td>

                <td>
                  {{ item.uom_name || "-" }}
                </td>

                <td style="min-width: 180px">
                  {{ item.dc_code || "-" }}
                </td>

                <td style="min-width: 180px">
                  {{ item.mst_corporate_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.supplier_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.departement_name || "-" }}
                </td>

                <td class="text-right">
                  {{ formatRupiahUtil(item.debit || 0) }}
                </td>

                <td class="text-right">
                  {{ formatRupiahUtil(item.credit || 0) }}
                </td>

                <td class="text-center sticky-excel">
                  <v-btn
                    v-if="item.object_excel"
                    icon
                    size="x-small"
                    color="primary"
                    variant="text"
                    @click="openDialogExcel(item.object_excel)"
                  >
                    <v-icon size="16">mdi-file-eye</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-divider />

        <!-- ACTION -->
        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            variant="outlined"
            color="secondary"
            @click="isDialogOpenRealizationByMonth = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog excel referensi -->
    <v-dialog v-model="isDialogExcel" max-width="500px">
      <v-card class="rounded-lg">
        <v-card-title class="text-h6 font-weight-bold">
          Realisasi Kartu Buku Besar (Excel)
        </v-card-title>

        <v-divider />

        <v-card-text v-if="selectedRealizationExcel">
          <v-row dense>
            <v-col cols="6">
              <strong>K2:</strong><br />
              {{ selectedRealizationExcel.k2 }}
            </v-col>

            <v-col cols="6">
              <strong>ACC:</strong><br />
              {{ selectedRealizationExcel.acc }}
            </v-col>

            <v-col cols="6">
              <strong>NO_ACCOUNT:</strong><br />
              {{ selectedRealizationExcel.no_account }}
            </v-col>

            <v-col cols="6">
              <strong>DATE:</strong><br />
              {{ selectedRealizationExcel.date }}
            </v-col>

            <v-col cols="6">
              <strong>DESCRIPTION:</strong><br />
              {{ selectedRealizationExcel.description }}
            </v-col>

            <v-col cols="6">
              <strong>DEBIT:</strong><br />
              {{ selectedRealizationExcel.debit }}
            </v-col>

            <v-col cols="6">
              <strong>CREDIT:</strong><br />
              {{ selectedRealizationExcel.credit }}
            </v-col>

            <!-- <v-col cols="6">
              <strong>ENDING:</strong><br />
              {{ selectedRealizationExcel.ending }}
            </v-col> -->
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn variant="outlined" @click="isDialogExcel = false">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />

    <!-- dialog COA -->
    <DialogCoa ref="dialogCoa" @success="handleSuccessCreateCoa" />
    <!-- dialog Item -->
    <DialogItem ref="dialogItem" @success="handleSuccessCreateItem" />

    <!-- dialog Uom -->
    <DialogUom ref="dialogUom" @success="handleSuccessCreateUom" />

    <!-- dialog Supplier -->
    <DialogSupplier
      ref="dialogSupplier"
      @success="handleSuccessCreateSupplier"
    />
    <!-- dialog chat -->
    <v-dialog v-model="isDialogChat" max-width="900">
      <v-card rounded="lg">
        <!-- Header -->
        <v-card-title class="d-flex align-center py-4">
          <v-icon class="mr-2">mdi-forum-outline</v-icon>
          {{ `Chat untuk item (${selectedChat.item_name})` }}

          <v-spacer />

          <v-chip size="small" color="primary" variant="tonal">
            {{ listChatDetail.length }} chat
          </v-chip>
        </v-card-title>

        <v-divider />

        <!-- Area Chat -->
        <v-card-text
          class="pa-4"
          style="height: 500px; overflow-y: auto; background: #f8fafc"
        >
          <div v-if="listChatDetail.length">
            <div
              v-for="history in listChatDetail"
              :key="history.id"
              class="mb-4"
            >
              <div
                class="d-flex"
                :class="
                  history.created_by === user.mst_employee_id
                    ? 'justify-end'
                    : 'justify-start'
                "
              >
                <div
                  class="d-flex align-end"
                  :class="
                    history.created_by === user.mst_employee_id
                      ? 'flex-row-reverse'
                      : ''
                  "
                  style="max-width: 75%"
                >
                  <!-- Avatar -->
                  <v-avatar
                    size="36"
                    color="primary"
                    :class="
                      history.created_by === user.mst_employee_id
                        ? 'ml-2'
                        : 'mr-2'
                    "
                  >
                    {{ history.created_by_name?.charAt(0)?.toUpperCase() }}
                  </v-avatar>

                  <!-- Bubble -->
                  <div>
                    <div
                      class="text-caption mb-1"
                      :class="
                        history.created_by === user.mst_employee_id
                          ? 'text-right'
                          : ''
                      "
                    >
                      <strong>
                        {{ history.created_by_name }}
                      </strong>
                      ·
                      {{ history.created_on }}
                    </div>

                    <v-sheet
                      rounded="xl"
                      class="pa-3"
                      :color="
                        history.created_by === user.mst_employee_id
                          ? 'white'
                          : 'white'
                      "
                      :class="
                        history.created_by === user.mst_employee_id ? '' : ''
                      "
                      style="border: 1px solid #e5e7eb; word-break: break-word"
                    >
                      {{ history.comments }}
                    </v-sheet>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-alert v-else type="info" variant="tonal">
            Belum ada chat.
          </v-alert>
        </v-card-text>

        <v-divider />

        <!-- Input Chat -->
        <div class="pa-4 bg-grey-lighten-5">
          <div class="d-flex align-end">
            <v-textarea
              v-model="selectedChat.comments"
              placeholder="Tulis chat..."
              variant="outlined"
              auto-grow
              rows="2"
              hide-details
              class="flex-grow-1"
              density="comfortable"
            />

            <v-btn
              color="primary"
              class="ml-3"
              size="large"
              icon
              @click="submitInsertDetailChat"
            >
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-actions class="justify-end">
          <v-btn
            variant="outlined"
            prepend-icon="mdi-close"
            @click="isDialogChat = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import { getCurrentYearRange } from "@/utils/date";
import { formatNumberRibuan, formatRupiahUtil } from "@/utils/formatter";
import DialogCoa from "@/components/DialogCoa.vue";
import DialogItem from "@/components/DialogItem.vue";
import DialogUom from "@/components/DialogUom.vue";
import DialogSupplier from "@/components/DialogSupplier.vue";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
    DialogCoa,
    DialogItem,
    DialogUom,
    DialogSupplier,
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      showMode: "qty",
      months: [
        { id: 1, key: "january", label: "Jan" },
        { id: 2, key: "february", label: "Feb" },
        { id: 3, key: "march", label: "Mar" },
        { id: 4, key: "april", label: "Apr" },
        { id: 5, key: "may", label: "May" },
        { id: 6, key: "june", label: "Jun" },
        { id: 7, key: "july", label: "Jul" },
        { id: 8, key: "august", label: "Aug" },
        { id: 9, key: "september", label: "Sep" },
        { id: 10, key: "october", label: "Oct" },
        { id: 11, key: "november", label: "Nov" },
        { id: 12, key: "december", label: "Dec" },
      ],
      currentYearRange: getCurrentYearRange(),
      yearOptions: Array.from({ length: 6 }, (_, i) => currentYear + i + 1),
      yearOptionsCreate: Array.from(
        { length: 6 },
        (_, i) => currentYear + i + 1,
      ),
      awsObjectUrl: process.env.VUE_APP_AWS_OBJECT_URL,
      awsPath: process.env.VUE_APP_AWS_PATH,
      tab: 1,
      tabItems: ["Budget"],
      tableHeaders: [
        { text: "Nomor Budget", align: "center", value: "transaction_number" },

        {
          text: "Kertas Kerja Budget",
          align: "center",
          value: "worksheet_budget_name",
        },

        {
          text: "Departement",
          align: "center",
          value: "departement_name",
        },

        {
          text: "Lokasi Kerja",
          align: "center",
          value: "dc_code",
        },

        {
          text: "Perusahaan",
          align: "center",
          value: "corporate_name",
        },
        { text: "PIC Persetujuan", align: "center", value: "step_name" },

        {
          text: "Status",
          align: "center",
          value: "last_status",
          width: "100px",
        },

        {
          text: "Riwayat Persetujuan",

          align: "center",
          value: "history_approval",
        },
        { text: "Dibuat Oleh", align: "center", value: "id" },

        {
          text: "Aksi",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      tableHeadersDetail: [
        {
          text: "Realisasi",
          align: "center",
          value: "realization",
          width: "80px",
        },
        {
          text: "Item",
          align: "center",
          value: "item_name",
          width: "150px",
        },
        {
          text: "Material",
          align: "center",
          value: "material_name",
          width: "150px",
        },
        {
          text: "Spesifikasi",
          align: "center",
          value: "spesification",
          width: "150px",
        },
        {
          text: "Satuan",
          align: "center",
          value: "uom_name",
          width: "120px",
        },

        // {
        //   text: "Catatan",
        //   align: "center",
        //   value: "note",
        //   width: "120px",
        // },

        {
          text: "Frekuensi",
          align: "center",
          value: "frekuensi",
          width: "120px",
        },

        {
          text: "Chat",
          align: "center",
          value: "comments",
          width: "120px",
        },

        // QTY
        ...[
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ].map((month) => ({
          text: `${month} Qty`,
          value: `${month.toLowerCase()}_qty`,
          width: "100px",
          type: "qty",
        })),

        // VALUE
        ...[
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ].map((month) => ({
          text: `${month} Values`,
          value: `${month.toLowerCase()}_total_price`,
          width: "130px",
          type: "values",
        })),

        {
          text: "Total Qty",
          value: "total_qty",
          align: "end",
          type: "qty",
        },

        {
          text: "Total Values",
          value: "total_values",
          align: "end",
          type: "values",
        },

        {
          text: "Aksi",
          align: "center",
          value: "actions",
          width: "80px",
        },
      ],
      tableHeadersApproval: [
        { text: "Name", align: "center", value: "step_name" },
        { text: "Status", align: "center", value: "status" },
        { text: "Catatan", align: "center", value: "comments" },
        { text: "Dibuat", align: "center", value: "created_by_name" },
        { text: "Tanggal", align: "center", value: "created_on" },
      ],
      tableHeadersPic: [
        { text: "Nama", align: "center", value: "mst_employee_name" },
        { text: "Email", align: "center", value: "mst_employee_email" },
      ],

      tableHeadersRealizationByWorksheetId: [
        {
          text: "Item",
          align: "center",
          value: "item_name",
          width: "200px",
        },

        {
          text: "Material",
          align: "center",
          value: "material_name",
          width: "200px",
        },

        {
          text: "Spesifikasi",
          align: "center",
          value: "spesification",
          width: "200px",
        },
        {
          text: "Satuan",
          align: "center",
          value: "uom_name",
          width: "100px",
        },
        // {
        //   text: "Catatan",
        //   align: "center",
        //   value: "note",
        //   width: "100px",
        // },

        {
          text: "Frekuensi",
          align: "center",
          value: "count_month_qty",
          width: "120px",
        },

        // MONTHLY QTY
        {
          text: "Jan",
          align: "center",
          value: "january_qty",
          width: "90px",
        },
        {
          text: "Feb",
          align: "center",
          value: "february_qty",
          width: "90px",
        },
        {
          text: "Mar",
          align: "center",
          value: "march_qty",
          width: "90px",
        },
        {
          text: "Apr",
          align: "center",
          value: "april_qty",
          width: "90px",
        },
        {
          text: "May",
          align: "center",
          value: "may_qty",
          width: "90px",
        },
        {
          text: "Jun",
          align: "center",
          value: "june_qty",
          width: "90px",
        },
        {
          text: "Jul",
          align: "center",
          value: "july_qty",
          width: "90px",
        },
        {
          text: "Aug",
          align: "center",
          value: "august_qty",
          width: "90px",
        },
        {
          text: "Sep",
          align: "center",
          value: "september_qty",
          width: "90px",
        },
        {
          text: "Oct",
          align: "center",
          value: "october_qty",
          width: "90px",
        },
        {
          text: "Nov",
          align: "center",
          value: "november_qty",
          width: "90px",
        },
        {
          text: "Dec",
          align: "center",
          value: "december_qty",
          width: "90px",
        },
        {
          text: "Total Qty",
          align: "center",
          value: "yearly_qty",
          width: "120px",
        },

        {
          text: "Total Harga",
          align: "center",
          value: "yearly_ending",
          width: "120px",
        },
      ],

      tableHeadersRealizationByMonth: [
        { text: "Account", align: "center", value: "account" },
        { text: "Tanggal", align: "center", value: "transaksi_date" },
        { text: "Item", align: "center", value: "item_name" },
        { text: "Material", align: "center", value: "material_name" },
        { text: "Spesifikasi", align: "center", value: "spesification" },
        { text: "qty", align: "center", value: "qty", width: "100px" },
        { text: "Satuan", align: "center", value: "uom_name" },
        // { text: "Catatan", align: "center", value: "note" },
        { text: "Lokasi Kerja", align: "center", value: "dc_code" },
        { text: "Perusahaan", align: "center", value: "mst_corporate_name" },
        { text: "Supplier", align: "center", value: "supplier_name" },
        { text: "Departemen", align: "center", value: "departement_name" },
        { text: "Debit", align: "center", value: "debit" },
        { text: "Kredit", align: "center", value: "credit", width: "100px" },
        {
          text: "",
          align: "center",
          value: "object_excel",
          width: "60px",
          class: "sticky-excel",
        },
      ],

      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: false,
        startMenu: false,
        endMenu: false,
        startDate: getCurrentYearRange().start,
        endDate: getCurrentYearRange().end,
        search: "",
        lastStatus: "all",
        worksheet: "all",
        departement_id: "all",
        site_id: "all",
        corporate_id: "all",
        year: currentYear + 1,
        cut_off: null,
        cut_off_yesterday: null,
      },
      formCreate: {
        year: currentYear + 1,
        worksheet: null,
        departement_id: null,
        site_id: null,
        corporate_id: null,
      },
      formCreateDetail: {
        item_id: null,
        material_id: null,
        spesification: null,
        searchItem: null,
        uom_id: null,
        frekuensi: null,
        qty: null,
        unit_price: null,
        total_price: null,
        total_price_budget: null,
        searchUom: null,
      },
      total: 0,
      List: [],
      listRealizationSuccessByMonth: [],
      listRealizationByWorksheetId: [],
      listRealizationByWorksheetIdAll: [],
      listDetail: [],
      listPf: [],
      listParameter: [],
      listItem: [],
      listMaterial: [],
      listCoa: [],
      listdepartement: [],
      listdepartementCreate: [],
      listSite: [],
      listSiteCreate: [],
      listCorporate: [],
      listCorporateCreate: [],
      listSupplier: [],
      listUom: [],
      listWorksheet: [],
      listStatus: [
        { name: "All", id: "all" },
        { name: "Created", id: "created" },
        { name: "Approved Supervisor", id: "Approved Supervisor" },
        {
          name: "Approved Head of Accounting & Finance",
          id: "Approved Head of Accounting & Finance",
        },
        {
          name: "Approved Head of Commercial Logistics",
          id: "Approved Head of Commercial Logistics",
        },
        { name: "Need To Analysis", id: "need to analysis" },
        { name: "Rejected", id: "rejected" },
      ],
      listWorksheetCreate: [],
      listPic: [],
      listChatDetail: [],
      ListShowQtyValues: ["qty", "values"],
      approvalList: [],
      isLoading: false,
      isDialogCreate: false,
      isDialogDetail: false,
      isDialogDelete: false,
      isDialogOpenApproval: false,
      isDialogOpenPic: false,
      isDialogCreateDetail: false,
      isDialogDeleteDetail: false,
      isDialogOpenRealizationByWorksheetId: false,
      isDialogOpenRealizationByMonth: false,
      isDialogExcel: false,
      isDialogChat: false,
      selectedItem: {},
      selectedItemDetail: {},
      selectedItemRealizationSuccess: {},
      selectedRealizationExcel: {},
      selectedChat: {
        comments: null,
        budget_id: null,
        item_id: null,
        item_name: null,
        material_id: null,
        spesification: null,
        fiscal_year: null,
      },
      isFormCreateValid: false,
      isFormCreateDetailValid: false,
      searchDetail: "",
    };
  },
  methods: {
    formatNumberRibuan,
    formatRupiahUtil,
    async fetch() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
        lastStatus: query.lastStatus || this.pagination.lastStatus,
        worksheet: query.worksheet || this.pagination.worksheet,
        departement_id: query.departement_id || this.pagination.departement_id,
        site_id: query.site_id || this.pagination.site_id,
        corporate_id: query.corporate_id || this.pagination.corporate_id,
        year: query.year || this.pagination.year,
      };

      await api
        .get("/budget", { params })
        .then(({ data }) => {
          // console.log(data);
          this.List = data.data.data;
          this.total = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async fetchPurchaseFrequency() {
      api
        .get("/pf")
        .then(({ data }) => {
          this.listPf = data.data.data;
          // console.log(this.listPf);
        })
        .catch((error) => {
          console.error("Error fetching item:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchParameter() {
      api
        .get("/parameters")
        .then(({ data }) => {
          this.listParameter = data.data.data;

          this.pagination.cut_off =
            this.listParameter.find(
              (e) =>
                e.fiscal_year == this.pagination.year &&
                e.name.toLowerCase() === "cut_off",
            )?.value || 1;

          this.pagination.cut_off_yesterday =
            this.listParameter.find(
              (e) =>
                e.fiscal_year == this.pagination.year - 1 &&
                e.name.toLowerCase() === "cut_off",
            )?.value || 1;

          // console.log(this.pagination.cut_off_yesterday);
        })

        .catch((error) => {
          console.error("Error fetching item:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchItem(item = null) {
      api
        .get("/items", { search: item?.searchItem })
        .then(({ data }) => {
          this.listItem = data.data.data;
          // console.log(this.listItem);
        })
        .catch((error) => {
          console.error("Error fetching item:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchCoa(item = null) {
      api
        .get("/coa", { search: item?.searchCoa })
        .then(({ data }) => {
          this.listCoa = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching Coa:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchdepartement() {
      api
        .get("/divisions", { search: null })
        .then(({ data }) => {
          const divisions = data.data.data || [];

          this.listdepartement = [
            {
              mst_division_id: "all",
              mst_division_name: "All",
            },
            ...divisions,
          ];

          // this.listdepartementCreate = divisions;
        })
        .catch((error) => {
          console.error("Error fetching departement:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    async fetchSite(item = null) {
      try {
        const { data } = await api.get("/sites", {
          params: {
            search: item?.searchSite || "",
            corporateId: 2,
          },
        });

        const sites = (data?.data?.data || []).filter(
          (e) => ![1163, 1164, 1165, 1395, 4].includes(e.mst_site_id),
        );

        this.listSite = [
          {
            mst_site_id: "all",
            dc_code: "All",
          },
          ...sites,
        ];

        this.listSiteCreate = sites;
      } catch (error) {
        console.error("Error fetching site:", error);

        store.dispatch("triggerSnackbar", {
          message: error?.response?.data?.message || "Failed fetch site",
          isSuccess: false,
        });
      } finally {
        store.dispatch("hideLoading");
      }
    },

    async fetchCorporate() {
      try {
        const { data } = await api.get("/corporates", {
          params: {
            category: "GROUP",
          },
        });

        const corporates = (data?.data?.data || []).filter((e) =>
          e.mst_corporate_name?.toLowerCase().includes("fastana"),
        );

        this.listCorporate = [
          {
            mst_corporate_id: "all",
            mst_corporate_name: "All",
          },
          ...corporates,
        ];

        this.listCorporateCreate = corporates;
      } catch (error) {
        store.dispatch("triggerSnackbar", {
          message: error?.response?.data?.message || "Failed fetch corporate",
          isSuccess: false,
        });
      } finally {
        store.dispatch("hideLoading");
      }
    },
    async fetchSupplier(item = null) {
      api
        .get("/supplier", { search: item?.searchSupplier })
        .then(({ data }) => {
          this.listSupplier = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching supplier:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchUom(item = null) {
      api
        .get("/uom", { search: item?.searchUom })
        .then(({ data }) => {
          this.listUom = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching Uom:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchWorksheet() {
      api
        .get("/wb")
        .then(({ data }) => {
          const worksheets = data.data.data;

          this.listWorksheet = [
            {
              id: "all",
              worksheet_name: "All",
            },
            ...worksheets,
          ];

          this.listWorksheetCreate = worksheets;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    async fetchMaterial() {
      api
        .get("/material")
        .then(({ data }) => {
          this.listMaterial = data.data.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    async openDialogCreate() {
      this.isDialogCreate = true;
    },

    async openDialogDetailCreate() {
      this.isDialogCreateDetail = true;
    },

    async openDialogDetail(item) {
      // Tampilkan loading
      this.selectedItem = item;

      // console.log(this.selectedItem);

      this.listDetail = [];
      store.dispatch("showLoading");
      this.isLoading = true;

      await api
        .get(`budget-detail/by-budget-id/${item.id}`)
        .then(({ data }) => {
          // console.log(data);
          this.listDetail = data.data || [];

          // console.log(this.listDetail);

          // console.log(this.listDetail);
          this.isDialogDetail = true;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async openDialogRealizationByWorksheetIdAll() {
      // Tampilkan loading
      this.isLoading = true;

      const params = {
        lastStatus: "success",
        worksheet: this.formCreate.worksheet,
        departementId: this.formCreate.departement_id,
        siteId: this.formCreate.site_id,
        corporateId: this.formCreate.corporate_id,
        year: this.formCreate.year,
        itemId: "all",
        materialId: "all",
        spesification: "all",
        uomId: "all",
      };

      await api
        .get("/realization/forbudget-byworksheetid", { params })
        .then(({ data }) => {
          this.listRealizationByWorksheetIdAll = data.data;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {});
    },

    async openDialogRealizationByWorksheetId(item) {
      // console.log(item);
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;

      const params = {
        lastStatus: "success",
        worksheet: item.worksheet_budget_id,
        departementId: item.departement_id,
        siteId: item.site_id,
        corporateId: item.corporate_id,
        year: item.fiscal_year,
        itemId: item.item_id,
        materialId: item.material_id,
        spesification: item.spesification,
        uomId: item.uom_id,
      };

      await api
        .get("/realization/forbudget-byworksheetid", { params })
        .then(({ data }) => {
          this.listRealizationByWorksheetId = data.data;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
      this.isDialogOpenRealizationByWorksheetId = true;
    },

    async openDialogRealizationSuccessByMonth(item, monthStart, monthEnd) {
      this.listRealizationSuccessByMonth = [];
      store.dispatch("showLoading");
      this.isLoading = true;

      const params = {
        worksheetId: item.worksheet_budget_id,
        itemId: item.item_id,
        materialId: item.material_id,
        spesification: item.spesification,
        uomId: item.uom_id,
        fiscalYear: item.fiscal_year,
        monthStart: monthStart,
        monthEnd: monthEnd,
        departementId: item.departement_id,
        siteId: item.site_id,
        corporateId: item.corporate_id,
        part: item.part,
      };

      await api
        .get("/realization/forbudget-bymonth", {
          params,
        })
        .then(({ data }) => {
          // console.log(data);
          this.listRealizationSuccessByMonth = data.data || [];
          this.isDialogOpenRealizationByMonth = true;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async openDialogApproval(id) {
      api
        .get(`/approvals/by-budget-id/${id}`)
        .then(({ data }) => {
          this.approvalList = data.data;
          this.isDialogOpenApproval = true;
        })
        .catch((error) => {
          this.isDialogOpenApproval = true;
          this.approvalList = [];
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async openDialogPic(params) {
      // console.log(params);
      this.listPic = params.list_pic;
      // console.log(this.listPic.list_pic);
      this.isDialogOpenPic = true;
      this.isLoading = false;
      store.dispatch("hideLoading");
    },

    async openDialogExcel(item) {
      this.selectedRealizationExcel = item;
      this.isDialogExcel = true;
    },

    async openDialogDelete(item) {
      this.selectedItem = item;
      this.isDialogDelete = true;
    },

    async openDialogDeleteDetail(item) {
      this.selectedItemDetail = item;
      this.isDialogDeleteDetail = true;
    },

    async openDialogChat(item) {
      this.selectedChat.item_name = item.item_name;
      this.selectedChat.budget_id = item.budget_id;
      this.selectedChat.item_id = item.item_id;
      this.selectedChat.material_id = item.material_id;
      this.selectedChat.spesification = item.spesification;
      this.selectedChat.fiscal_year = item.fiscal_year;

      const params = {
        budget_id: item.budget_id,
        item_id: item.item_id,
        material_id: item.material_id,
        spesification: item.spesification,
        fiscal_year: item.fiscal_year,
      };
      // console.log(this.selectedItem);
      this.listChatDetail = [];
      store.dispatch("showLoading");
      this.isLoading = true;

      await api
        .get(`chats`, { params })
        .then(({ data }) => {
          // console.log(data.data);
          this.listChatDetail = data.data || [];

          // console.log(this.listDetail);

          // console.log(this.listDetail);
          this.isDialogChat = true;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async submitCreate() {
      store.dispatch("showLoading");

      await this.openDialogRealizationByWorksheetIdAll();

      const payload = {
        cart: this.listRealizationByWorksheetIdAll,
        worksheet_budget_id: this.formCreate.worksheet,
        departement_id: this.formCreate.departement_id,
        site_id: this.formCreate.site_id,
        corporate_id: this.formCreate.corporate_id,
        year: this.formCreate.year,
        cut_off: this.pagination.cut_off,
        fiscal_year: this.formCreate.year,
        kenaikan_harga:
          this.listWorksheetCreate.find(
            (item) => item.id === this.formCreate.worksheet,
          )?.kenaikan_harga || 0,
      };

      api
        .post("/budget", payload)
        .then((response) => {
          const message = response.data.message;

          this.isDialogOpenRealizationByWorksheetIdAll = false;
          this.isDialogCreate = false;

          this.formCreate.worksheet = null;
          this.formCreate.departement_id = null;
          this.formCreate.site_id = null;
          this.formCreate.corporate_id = null;

          store.dispatch("triggerSnackbar", { message, isSuccess: true });
          this.fetch();
        })
        .catch((error) => {
          let message = "Failed to save parameter!";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitUpdateStepId() {
      // console.log(this.selectedItem);
      store.dispatch("showLoading");
      const payload = {
        id: this.selectedItem.id,
      };

      api
        .post("/budget/update-stepid", payload)
        .then(() => {
          store.dispatch("triggerSnackbar", {
            message: "Insert Budget Success",
            isSuccess: true,
          });

          this.isDialogCreateDetail = false;
          this.isDialogDetail = false;
          this.formCreateDetail.item_id = null;
          this.formCreateDetail.uom_id = null;

          this.fetch();
        })

        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          // this.isDialogDetail = false;
          // this.openDialogDetail(this.selectedItem);
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitUpdateKenaikanHarga() {
      store.dispatch("showLoading");

      await this.openDialogRealizationByWorksheetIdAll();

      const payload = {
        id: this.selectedItem.id,
        worksheet_budget_id: this.selectedItem.worksheet_budget_id,
        departement_id: this.selectedItem.departement_id,
        site_id: this.selectedItem.site_id,
        corporate_id: this.selectedItem.corporate_id,
        year: this.selectedItem.fiscal_year,
        cut_off: this.pagination.cut_off,
        kenaikan_harga: this.selectedItem?.kenaikan_harga,
      };
      api
        .post("/budget/update-kenaikanharga", payload)
        .then((response) => {
          const message = response.data.message;

          this.openDialogDetail(this.selectedItem);

          if (status == "success") {
            store.dispatch("triggerSnackbar", { message, isSuccess: true });
          }
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    submitDelete() {
      this.isLoading = true;

      const payload = {
        status: "cancel",
        id: this.selectedItem.id,
      };

      api
        .post("/budget/update-status", payload)
        .then(() => {
          this.List = this.List.filter((e) => e.id !== this.selectedItem.id);

          store.dispatch("triggerSnackbar", {
            message: "Budget berhasil dibatalkan.",
            isSuccess: true,
          });

          this.isDialogDelete = false;

          this.$nextTick(() => {
            this.selectedItem = {};
          });
        })
        .catch((error) => {
          let message = "Terjadi kesalahan saat membatalkan budget.";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async submitCreateDetail() {
      // console.log(this.selectedItem);
      store.dispatch("showLoading");
      const payload = {
        budget_id: this.selectedItem.id,
        year: this.pagination.year,
        month_id: this.pagination.month_id,
        item_id: this.formCreateDetail.item_id,
        material_id: this.formCreateDetail.material_id,
        spesification: this.formCreateDetail.spesification,
        uom_id: this.formCreateDetail.uom_id,
        frekuensi: this.formCreateDetail.frekuensi,
        qty: this.formCreateDetail.qty,
        total_price: this.formCreateDetail.total_price,
        unit_price: this.formCreateDetail.unit_price,
        kenaikan_harga: this.selectedItem.kenaikan_harga || 0,
      };

      api
        .post("/budget-detail", payload)
        .then(() => {
          // console.log(response.data.data);
          // this.listDetail.unshift({
          //   id: response.data.data,
          //   budget_id: this.selectedItem.id,
          //   year: this.pagination.year,
          //   month_id: this.pagination.month_id,
          //   item_id: this.pagination.item_id,
          // });

          // const message = response.data.message;
          store.dispatch("triggerSnackbar", {
            message: "Insert Budget Success",
            isSuccess: true,
          });

          this.isDialogCreateDetail = false;
          // this.isDialogDetail = false;
          this.formCreateDetail.item_id = null;
          this.formCreateDetail.spesification = null;
          this.formCreateDetail.material_id = null;
          this.formCreateDetail.uom_id = null;
          this.formCreateDetail.frekuensi = null;
          this.formCreateDetail.qty = null;
          this.formCreateDetail.total_price = null;
          this.formCreateDetail.unit_price = null;
          this.formCreateDetail.total_price = null;
          this.formCreateDetail.total_price_budget = null;
          this.openDialogDetail(this.selectedItem);
        })

        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          // this.isDialogDetail = false;
          // this.openDialogDetail(this.selectedItem);
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitUpdateDetail(
      column,
      value,
      month_id,
      year,
      item_id,
      material_id,
      spesification,
    ) {
      // console.log(value);
      if (!value) {
        return;
      }
      store.dispatch("showLoading");
      const payload = {
        budget_id: this.selectedItem.id,
        column: column,
        value: value,
        item_id: item_id,
        material_id: material_id,
        spesification: spesification,
        month_id: month_id,
        year: year,
      };

      api
        .post("/budget-detail/update", payload)
        .then((response) => {
          const message = response.data.message;
          store.dispatch("triggerSnackbar", {
            message: message,
            isSuccess: true,
          });
          // this.openDialogDetail(this.selectedItem);
        })
        .catch((error) => {
          this.isDialogDetail = false;
          this.listDetail = [];
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitUpdateDetailFrekuensi(
      value,
      month_id,
      year,
      is_new,
      item_id,
      material_id,
      uom_id,
      spesification,
      yearly_total_qty,
      yearly_total_price,
    ) {
      // console.log(value);
      if (!value) {
        return;
      }
      store.dispatch("showLoading");
      const payload = {
        budget_id: this.selectedItem.id,
        frekuensi: value,
        item_id: item_id,
        material_id: material_id,
        uom_id: uom_id,
        spesification: spesification,
        month_id: month_id,
        year: year,
        is_new: is_new,
        yearly_total_qty: yearly_total_qty,
        yearly_total_price: yearly_total_price,
      };

      api
        .post("/budget-detail/update-frekuensi", payload)
        .then((response) => {
          const message = response.data.message;
          store.dispatch("triggerSnackbar", {
            message: message,
            isSuccess: true,
          });
          this.isDialogCreateDetail = false;

          this.openDialogDetail(this.selectedItem);
        })
        .catch((error) => {
          this.isDialogDetail = false;
          this.listDetail = [];
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitUpdateDetailNote(
      value,
      year,
      item_id,
      material_id,
      spesification,
      uom_id,
    ) {
      // console.log(value);
      if (!value) {
        return;
      }
      store.dispatch("showLoading");
      const payload = {
        value: value,
        budget_id: this.selectedItem.id,
        item_id: item_id,
        material_id: material_id,
        spesification: spesification,
        uom_id: uom_id,
        year: year,
      };

      api
        .post("/budget-detail/update-note", payload)
        .then((response) => {
          const message = response.data.message;
          store.dispatch("triggerSnackbar", {
            message: message,
            isSuccess: true,
          });
          this.isDialogCreateDetail = false;

          this.openDialogDetail(this.selectedItem);
        })
        .catch((error) => {
          this.isDialogDetail = false;
          this.listDetail = [];
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitDeleteDetail() {
      const payload = {
        item_id: this.selectedItemDetail.item_id,
        spesification: this.selectedItemDetail.spesification,
        year: this.selectedItemDetail.fiscal_year,
      };

      api
        .post("/budget-detail/update-status", payload)
        .then(() => {
          this.openDialogDetail(this.selectedItem);
          store.dispatch("triggerSnackbar", {
            message: "Delete Success",
            isSuccess: true,
          });

          this.isDialogDeleteDetail = false;
        })
        .catch((error) => {
          let message = "Failed to save parameter!";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitInsertDetailChat() {
      store.dispatch("showLoading");
      const payload = {
        budget_id: this.selectedItem.id,
        step_id: this.selectedItem.step_id,
        comments: this.selectedChat.comments,
        item_id: this.selectedChat.item_id,
        material_id: this.selectedChat.material_id,
        spesification: this.selectedChat.spesification,
        fiscal_year: this.selectedChat.fiscal_year,
      };

      api
        .post("/chats", payload)
        .then((response) => {
          const message = response.data.message;
          store.dispatch("triggerSnackbar", {
            message: message,
            isSuccess: true,
          });
          this.openDialogChat(this.selectedChat);
          this.selectedChat.comments = null;
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    onSearchItem(item) {
      if (!item.searchItem || item.searchItem.length < 2) return;
      this.fetchItem(item);
    },
    onSearchCoa(item) {
      if (!item.searchCoa || item.searchCoa.length < 2) return;
      this.fetchCoa(item);
    },

    onSearchdepartement(item) {
      if (!item.searchdepartement || item.searchdepartement.length < 2) return;
      this.fetchdepartement(item);
    },

    onSearchSite(item) {
      if (!item.searchSite || item.searchSite.length < 2) return;
      this.fetchSite(item);
    },

    onSearchCorporate(item) {
      if (!item.searchCorporate || item.searchCorporate.length < 2) return;
      this.fetchCorporate(item);
    },

    onSearchSupplier(item) {
      if (!item.searchSupplier || item.searchSupplier.length < 2) return;
      this.fetchSupplier(item);
    },

    onSearchUom(item) {
      if (!item.searchUom || item.searchUom.length < 2) return;
      this.fetchUom(item);
    },

    onStatusChange() {
      this.updateQuery("lastStatus", this.pagination.lastStatus); // Update endDate
    },

    getStatusColor(status) {
      if (!status) return "default";

      const s = status.toLowerCase();

      if (s.includes("approved")) return "success";

      switch (s) {
        case "pending":
          return "warning";
        case "success":
          return "success";
        case "cancel":
          return "grey";
        case "rejected":
          return "error";
        case "need to analysis":
          return "orange";
        default:
          return "default";
      }
    },

    openCoaDialog(item) {
      this.selectedItemRealizationSuccess = item;
      this.$refs.dialogCoa.openDialogCreate(item);
    },
    openItemDialog(item) {
      this.$refs.dialogItem.openDialogCreate(item);
    },
    openUomDialog(item) {
      this.selectedItemRealizationSuccess = item;
      this.$refs.dialogUom.openDialogCreate(item);
    },
    openSupplierDialog(item) {
      this.selectedItemRealizationSuccess = item;
      this.$refs.dialogSupplier.openDialogCreate(item);
    },
    async handleSuccessCreateCoa() {
      await this.fetchCoa();
    },
    async handleSuccessCreateItem() {
      await this.fetchItem();
    },
    async handleSuccessCreateUom() {
      await this.fetchUom();
    },
    async handleSuccessCreateSupplier() {
      await this.fetchSupplier();
    },

    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 5;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
      this.pagination.worksheet =
        parseInt(query.worksheet) || this.pagination.worksheet;
      this.pagination.departement_id =
        parseInt(query.departementId) || this.pagination.departement_id;

      this.pagination.site_id =
        parseInt(query.siteId) || this.pagination.site_id;

      this.pagination.corporate_id =
        parseInt(query.corporateId) || this.pagination.corporate_id;
      this.pagination.year = parseInt(query.year) || this.pagination.year;
      this.pagination.lastStatus =
        query.lastStatus || this.pagination.lastStatus;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },

    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }
    },

    onYearChange() {
      // this.fetch();
      this.updateQuery("year", this.pagination.year); // Update endDa
    },

    onWorksheetChange() {
      this.updateQuery("worksheet", this.pagination.worksheet); // Update endDa
    },

    onWorksheetChangeCreate() {
      const selectedWorksheet = this.listWorksheetCreate.find(
        (e) => e.id === this.formCreate.worksheet,
      );

      const part = selectedWorksheet?.part;

      this.formCreate.departement_id = null;

      this.listdepartementCreate = this.listdepartement
        .filter((e) => e.mst_division_id !== "all")
        .map((e) => ({
          ...e,
          disabled: part ? e.part !== part : false,
        }));
    },

    ondepartementChange() {
      // this.fetch();
      this.updateQuery("departementId", this.pagination.departement_id); // Update endDate
    },

    onsiteChange() {
      // this.fetch();
      this.updateQuery("siteId", this.pagination.site_id); // Update endDate
    },

    oncorporateChange() {
      // this.fetch();
      this.updateQuery("corporateId", this.pagination.corporate_id); // Update endDate
    },

    getItemTotalQty(item) {
      return this.months.reduce((total, month) => {
        // console.log(Number(item[`${month.key}_qty`]));
        return total + Number(item[`${month.key}_qty`] || 0);
      }, 0);
    },
    getItemTotalPrice(item) {
      return this.months.reduce((total, month) => {
        return total + Number(item[`${month.key}_total_price`] || 0);
      }, 0);
    },
    calculateTotalPrice() {
      const qty = Number(this.formCreateDetail.qty) || 0;
      const unitPrice = Number(this.formCreateDetail.unit_price) || 0;
      const kenaikanHarga = Number(this.selectedItem?.kenaikan_harga) || 0;

      const totalPrice = qty * unitPrice;

      this.formCreateDetail.total_price = totalPrice;
      this.formCreateDetail.total_price_budget =
        totalPrice + (totalPrice * kenaikanHarga) / 100;
    },
  },
  watch: {
    pagination: {
      handler: "fetch",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },

  mounted() {
    store.commit("setTitle", "Budget");
    this.fetchPurchaseFrequency();
    this.fetchItem();
    this.fetchCoa();
    this.fetchdepartement();
    this.fetchSite();
    this.fetchCorporate();
    this.fetchSupplier();
    this.fetchUom();
    this.fetchWorksheet();
    this.fetchParameter();
    this.fetch();
    this.fetchMaterial();
    this.updatePagination(this.$route.query);
  },

  computed: {
    user() {
      return store.getters["user/getUser"] || {};
    },
    title() {
      return store.state.title;
    },
    isQty() {
      return this.showMode === "qty" || this.showMode === "all";
    },

    isValues() {
      return this.showMode === "values" || this.showMode === "all";
    },

    tableHeadersDetailFiltered() {
      return this.tableHeadersDetail.filter((header) => {
        if (!header.type) return true;

        if (this.showMode === "qty") {
          return header.type === "qty";
        }

        if (this.showMode === "values") {
          return header.type === "values";
        }

        if (this.showMode === "all") {
          return ["qty", "values"].includes(header.type);
        }

        return true;
      });
    },
    filteredListDetail() {
      const keyword = (this.searchDetail || "").toLowerCase().trim();

      if (!keyword) return this.listDetail;

      return this.listDetail.filter(
        (item) =>
          item.item_name?.toLowerCase().includes(keyword) ||
          item.material_name?.toLowerCase().includes(keyword) ||
          item.spesification?.toLowerCase().includes(keyword) ||
          item.uom_name?.toLowerCase().includes(keyword),
      );
    },
  },
};
</script>

<style scoped>
.custom-autocomplete .v-field__input {
  font-size: 8px !important;
}

.custom-autocomplete .v-list-item-title {
  font-size: 8px !important;
}

.v-data-table thead th {
  text-align: center;
  vertical-align: middle;
}

.custom-table th,
.custom-table td {
  white-space: nowrap;
}

.table-wrapper table th,
.table-wrapper table td {
  white-space: nowrap;
}

.no-wrap-table td,
.no-wrap-table th {
  white-space: nowrap;
}

.sticky-excel {
  position: sticky;
  right: 0px;
  background: white;
  z-index: 2;
}

.sticky-action {
  position: sticky;
  right: 0;
  background: white;
  z-index: 3;
}

.month-input {
  width: 75px;
}

.month-input :deep(.v-field) {
  min-height: 34px !important;
  border-radius: 8px !important;
}

.month-input :deep(.v-field__input) {
  min-height: 34px !important;
  padding: 0 8px !important;
}

.month-input :deep(input) {
  text-align: center;
  font-size: 13px;
  font-weight: 500;
}

.budget-table {
  font-size: 13px;
}

.budget-table :deep(thead th) {
  background: #f5f7fa;
  font-weight: 600;
  white-space: nowrap;
}

.month-input {
  min-width: 90px;
}

.month-input :deep(input) {
  text-align: center;
}

.sticky-realization {
  position: sticky;
  left: 0;
  z-index: 2;
  background: white;
}

.sticky-action {
  position: sticky;
  right: 0;
  z-index: 2;
  background: white;
}

.v-card-title {
  min-height: 90px;
}

.dialog-header {
  position: relative;
  background: #fff;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
}

.new-item-row {
  background-color: #b3e2bd !important;
  border-left: 4px solid #2e7d32;
}

.new-item-row:hover {
  background-color: #b3e2bd !important;
}

.dialog-footer-sticky {
  position: sticky;
  bottom: 0;
  z-index: 100;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 16px 24px;

  background: #fff;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
}
</style>
